import React from "react";
import CustomButton from "../shared/CustomButton";
import appConst from "../Utilities/appConst.json";
import useBrazeScreenView from "../hooks/useBrazeScreenView";

const PaymentError = () => {
  useBrazeScreenView();
  return (
    <>
      <CustomButton
        nextPage={appConst.NINTH_PAGE}
        variant="contained"
        color="primary"
        disabled={false}
      ></CustomButton>
    </>
  );
};
export default PaymentError;
